import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import SessionActionsMenu, { type SessionActionsMenuProps } from './SessionActionsMenu';
import { formatSessionDate } from './formatSessionDate';

export interface VerificationSessionRowProps extends SessionActionsMenuProps {
  selected: boolean;
}

const VerificationSessionRow: React.FC<VerificationSessionRowProps> = ({
  session,
  selected,
  onSessionSelect,
  onSessionDelete,
  onSessionExport,
}) => {
  const { t } = useTranslation();

  return (
    // The overflow menu is a sibling of the row button, not a child: nesting it
    // would put a button inside a button and make every menu click select the row.
    <li className="relative">
      <button
        type="button"
        aria-current={selected ? 'true' : undefined}
        onClick={() => onSessionSelect(session)}
        className={cn(
          'w-full rounded-md py-2 pl-3 pr-10 text-left transition-colors hover:bg-accent/60',
          selected && 'bg-accent',
        )}
      >
        <p className="revy-cjk text-sm font-medium leading-[1.5]">{session.title}</p>
        {session.modelName && (
          <span className="revy-cjk block text-xs leading-[1.5] text-muted-foreground">
            {t('verification.modelName')}: {session.modelName}
          </span>
        )}
        <span className="revy-cjk block text-xs leading-[1.5] text-muted-foreground">
          <span className="revy-figure">{formatSessionDate(session.createdAt)}</span>
          {session.units.length > 0 && ` | ${session.units.length} ${t('verification.units')}`}
        </span>
      </button>
      <SessionActionsMenu
        session={session}
        onSessionSelect={onSessionSelect}
        onSessionDelete={onSessionDelete}
        onSessionExport={onSessionExport}
      />
    </li>
  );
};

export default VerificationSessionRow;
